"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsToJSON = exports.PermissionsFromJSONTyped = exports.PermissionsFromJSON = void 0;
var runtime_1 = require("../runtime");
function PermissionsFromJSON(json) {
    return PermissionsFromJSONTyped(json, false);
}
exports.PermissionsFromJSON = PermissionsFromJSON;
function PermissionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'autologin': !(0, runtime_1.exists)(json, 'autologin') ? undefined : json['autologin'],
        'serviceMail': !(0, runtime_1.exists)(json, 'serviceMail') ? undefined : json['serviceMail'],
        'eInvoice': !(0, runtime_1.exists)(json, 'eInvoice') ? undefined : json['eInvoice'],
        'postalBankStatement': !(0, runtime_1.exists)(json, 'postalBankStatement') ? undefined : json['postalBankStatement'],
        'newsletter': !(0, runtime_1.exists)(json, 'newsletter') ? undefined : json['newsletter'],
        'neighboursDelivery': !(0, runtime_1.exists)(json, 'neighboursDelivery') ? undefined : json['neighboursDelivery'],
        'smsNotifications': !(0, runtime_1.exists)(json, 'smsNotifications') ? undefined : json['smsNotifications'],
        'parcelShopSMS': !(0, runtime_1.exists)(json, 'parcelShopSMS') ? undefined : json['parcelShopSMS'],
        'parcelShopSMSIndex': !(0, runtime_1.exists)(json, 'parcelShopSMSIndex') ? undefined : json['parcelShopSMSIndex'],
    };
}
exports.PermissionsFromJSONTyped = PermissionsFromJSONTyped;
function PermissionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'autologin': value.autologin,
        'serviceMail': value.serviceMail,
        'eInvoice': value.eInvoice,
        'postalBankStatement': value.postalBankStatement,
        'newsletter': value.newsletter,
        'neighboursDelivery': value.neighboursDelivery,
        'smsNotifications': value.smsNotifications,
        'parcelShopSMS': value.parcelShopSMS,
        'parcelShopSMSIndex': value.parcelShopSMSIndex,
    };
}
exports.PermissionsToJSON = PermissionsToJSON;
//# sourceMappingURL=Permissions.js.map